import { onBeforeMount, onUnmounted } from 'vue'
import type { IFrameIncomingEvent, IFrameIncomingPostMessageCallbacks, IFrameIncomingPostMessageData } from '@/types'

const useIFrameIncomingMsg = (callbacks: IFrameIncomingPostMessageCallbacks = {}) => {
	const callbacksMap = new Map<string, (payload: unknown) => void>()
	let isRegistered = false

	function handleIFrameIncomingMessages(e: IFrameIncomingPostMessageData) {
		const eventType = e.data?.type

		if (e.data && eventType) {
			const payload = e.data.payload
			const callback = callbacksMap.get(eventType)

			if (callback) {
				callback(payload)
			}
		}
	}

	const addCallbacks = (callbacks: IFrameIncomingPostMessageCallbacks) => {
		Object.entries(callbacks).forEach(([key, callback]) => {
			callbacksMap.set(key, callback as (payload: unknown) => void)
		})
	}

	const removeCallbacks = (eventTypes: IFrameIncomingEvent[]) => {
		eventTypes.forEach((eventType) => callbacksMap.delete(eventType))
	}

	const addEventListener = () => {
		if (!isRegistered) {
			window.addEventListener('message', handleIFrameIncomingMessages)
			isRegistered = true
		}
	}

	const removeEventListener = () => {
		window.removeEventListener('message', handleIFrameIncomingMessages)
		callbacksMap.clear()
		isRegistered = false
	}

	onBeforeMount(() => {
		addEventListener()
	})

	onUnmounted(() => {
		removeEventListener()
	})

	addCallbacks(callbacks)

	return {
		addCallbacks,
		removeCallbacks,
		removeEventListener
	}
}

export default useIFrameIncomingMsg
